var render = function render(){var _vm=this,_c=_vm._self._c;return _c('protocol-form',{attrs:{"protocol":_vm.protocol,"loading":_vm.loading,"disabled":_vm.disabled,"config":_vm.config,"parameter-options":_vm.parameterOptions,"simple-parameter-options":_vm.simpleParameterOptions},on:{"update-protocol":function($event){_vm.protocol = $event},"change-config":function($event){_vm.config = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }